import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import styles from './CheckoutInfographic.module.scss';
import React from 'react';
import Bank from 'images/icons/bank.svg';
import CreditCardCheck from 'images/icons/credit-card-check.svg';
import Keys from 'images/icons/keys.svg';
import { TextV2 } from 'components/TextV2/TextV2';

export const CheckoutInfographic = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={cx(styles.wrapper, styles.imgWrapper)} aria-hidden>
        <img src={Keys} className={styles.icon} />
        <span className={styles.line} />
        <img src={Bank} className={styles.icon} />
        <span className={styles.line} />
        <img src={CreditCardCheck} className={styles.icon} />
      </div>

      <div className={cx(styles.wrapper, styles.textWrapper)}>
        <TextV2 tagName="p" variant="body-small-bold" value={t('checkout-infographic.step-one')} />
        <TextV2 tagName="p" variant="body-small-bold" value={t('checkout-infographic.step-two')} />
        <TextV2 tagName="p" variant="body-small-bold" value={t('checkout-infographic.step-three')} />
      </div>
    </div>
  );
};
